export const languageOptions = [
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'en', label: 'Inglés', flag: '🇺🇸' },
  { code: 'pt', label: 'Portugués', flag: '🇵🇹' },
  { code: 'fr', label: 'Francés', flag: '🇫🇷' },
];

export const defaultLanguage = 'es';

export const getLanguageOption = (code) =>
  languageOptions.find((option) => option.code === code) ||
  languageOptions.find((option) => option.code === defaultLanguage);
